function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary primary-fill",
  fill: "#3D84FF",
  d: "M33.456 14.481a.985.985 0 0 0-.7-.302c-.25 0-.5.1-.7.302L21.797 24.8l-3.803-3.825c-.4-.403-1.051-.403-1.401 0l-4.353 4.278a.977.977 0 0 0 0 1.409l8.806 8.858c.2.201.45.302.7.302.25 0 .501-.1.701-.302l15.311-15.3a.977.977 0 0 0 0-1.41l-4.303-4.328zM21.798 33.405l-7.406-7.449 2.902-2.919 3.803 3.825c.2.202.45.302.7.302.25 0 .501-.1.701-.302l10.258-10.317 2.902 2.919-13.86 13.941z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "secondary secondary-stroke",
  cx: 25,
  cy: 25,
  r: 25,
  stroke: "#434957",
  strokeWidth: 2
}));

const SvgIcCheckCircle = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCheckCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-check-circle.647ac9c2.svg";
export { ForwardRef as ReactComponent };